import { createFileRoute, Outlet } from '@tanstack/react-router';

// 班级进度区域的布局。表格（index）和教师深入查看
// 某学生（students/$studentId）均通过此 Outlet 渲染。
// 保持纯透传（无包装）使两者都不获得额外容器——
// 没有此 Outlet 嵌套的学生页面永远不会挂载。
export const Route = createFileRoute('/_learner/courses_/$id/class-progress')({
  component: () => <Outlet />,
});
